var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"width":'100%',"elevation":4}},[_c('v-container',[_c('p',[_vm._v("Emails:")]),_c('EmailsContainer',{attrs:{"emails":_vm.emails}}),_c('EmailForm',{staticClass:"mt-5"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }